"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = require("../../Icon");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      backgroundColor: palette.primary.main,
      color: palette.common.white
    },
    icon: {
      fontSize: 20,
      margin: spacing(3),
      transform: 'rotate(45deg)',
      color: palette.common.white,
      cursor: 'pointer'
    }
  };
});

var ProductSidebarHeader = function ProductSidebarHeader(_ref2) {
  var children = _ref2.children,
      onClose = _ref2.onClose,
      _ref2$overrideClasses = _ref2.overrideClasses,
      overrideClasses = _ref2$overrideClasses === void 0 ? {} : _ref2$overrideClasses,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref2, ["children", "onClose", "overrideClasses"]);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.root, overrideClasses.sidebarHeaderRoot),
    height: 80,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "common.white"
  }, boxProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 320
  }, children), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: (0, _classnames["default"])(classes.icon, overrideClasses.sidebarHeaderIcon),
    icon: "plus",
    color: "inherit",
    onClick: onClose
  }));
};

ProductSidebarHeader.propTypes = {
  children: _propTypes["default"].node.isRequired,
  onClose: _propTypes["default"].func.isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductSidebarHeader);

exports["default"] = _default;